/* 


@PRAKT


   _____________________________________________________________

   |
   | GALLERY
   |
   _____________________________________________________________
*/

import gsap from 'gsap';
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
gsap.registerPlugin(ScrollToPlugin);

/* ______________________________________________________________

   |
   | CLASS
   |
   ______________________________________________________________
*/

export default class Gallery {
	constructor( ref_ ) {
		this.ref = ref_;
		this.slides = [];
		this.counter = 0;
		this.total;
		this.init();
	}

	init() {
		this.setupSlides();
		this.addNavigation();
		this.navigation();
		this.scrollObserver();
	}

	setupSlides() {
		this.scroll_container = this.ref.querySelectorAll( '.inner_container' );
		this.images = this.ref.querySelectorAll( '.inner_container img' );
		let count = 0;
		this.images.forEach( i => {
			const parent = i.parentNode;
			parent.setAttribute( 'data-id', count );
			parent.className = 'item';
			this.slides.push( parent );
			count++;
		});
		this.total = this.images.length;
	}

	addNavigation() {
		const navigation = document.createElement( 'div' );
		const prev = document.createElement( 'div' );
		const next = document.createElement( 'div' );
		prev.className = 'prev';
		next.className = 'next';
		navigation.className = 'navigation';
		navigation.appendChild( prev );
		navigation.appendChild( next );
		this.ref.appendChild( navigation );
	}

	navigation() {
		const prev = this.ref.querySelector( '.prev' );
		const next = this.ref.querySelector( '.next' );
		prev.addEventListener( 'click', () => {
			if( this.counter > 0 ) {
				this.counter--;
			} else {
				this.counter = this.total - 1;
			}
			this.scrollToItem();
			
		} );
		next.addEventListener( 'click', () => {
			if( this.counter < this.total - 1 ) {
				this.counter++;
			} else {
				this.counter = 0;
			}
			this.scrollToItem();
			
		} );
	}

	scrollToItem() {
		let target = this.slides[ this.counter ];
		if( this.counter == 0 ) target = 0;
		gsap.to( this.scroll_container, {
			duration: 1,
			ease: 'power3.inOut',
			scrollTo: {
				x: target
			}
		} );
	}

	scrollObserver() {
        let options = {
            // root: null,
            rootMargin: '0px',
            threshold: 0.5,
        };

        let callback = ( entries, observer ) => {
            // Each entry describes an intersection change for one observed
            // target element:
            //   entry.boundingClientRect
            //   entry.intersectionRatio
            //   entry.intersectionRect
            //   entry.isIntersecting
            //   entry.rootBounds
            //   entry.target
            //   entry.time
            entries.forEach( ( entry ) => {    
                if( entry.isIntersecting ) {
                    let intersecting_entry_id = Number( entry.target.dataset.id );
                    this.counter = intersecting_entry_id;
                }
            } );
        };
        this.scroll_observer = new IntersectionObserver( callback, options );
        this.slides.forEach( e => {
            this.scroll_observer.observe( e );
        });
    }

    killScrollObserver() {
        this.slides.forEach( e => {
            this.scroll_observer.unobserve( e );
        });
        this.scroll_observer.disconnect();
    }
}